import { atom } from 'jotai';

// Initialise to `true` since 99% users have no issue loading stripe
export const isStripeLoadedAtom = atom<boolean>(true);
